import { render } from "./icon-failed.vue?vue&type=template&id=4175cbd2"
import script from "./icon-failed.vue?vue&type=script&lang=js"
export * from "./icon-failed.vue?vue&type=script&lang=js"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__